import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=d495333c&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=js"
export * from "./shopDetails.vue?vue&type=script&lang=js"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=d495333c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d495333c",
  null
  
)

export default component.exports